import {
  APIStatus,
  CampaignType,
  EarningRuleRewardType,
  LanguageConfig,
  TARGET_CUSTOMER_TYPE,
} from 'config/CustomEnums';
import { createModel } from 'models/BaseModel';
import { defaultStepV2, getNewStepConfigV2 } from 'models/StepBarUtil';

export const stepNamesConfig = {
  "normal": ['Type', 'Content', 'Rule & Properties', 'Preview'],
  "withCoupon": ['Type', 'Content', 'Rule & Properties', 'Coupon Set', 'Preview'],
  messgaeCampaign: ['Content', 'Preview'],
  stampCampaign: ['Content', 'Rule & Properties', 'Rewards', 'Preview'],
  ticketCampaign: ['Content', 'Rule & Properties', 'Preview'],
}

export const getStepWithCoupon = ({
  campaignType,
  earningRuleRewardType,
  haveCreatedCoupon,
}) => {
  if (
    campaignType === CampaignType.earningRulesCampaign
    && earningRuleRewardType === EarningRuleRewardType.coupons
    && !haveCreatedCoupon
  ) {
    return true;
  };

  if (
    campaignType === CampaignType.couponsCampaign
    && !haveCreatedCoupon
  ) {
    return true;
  };

  return false;
};

const getInitialState = () => ({
  stepWithCoupon: false,
  stepConfig: defaultStepV2({ nameList: stepNamesConfig.normal, hideFirstStep: true }),
  currentStep: 0,
  anchorKey: null,
  sectionKey: null,
});


export default createModel({
  namespace: 'campaignStreamline',
  states: getInitialState(),

  reducers: {
    updateSteps(state, { payload }) {
      const { stepWithCoupon, customNameList, hideFirstStep = true } = payload;
      let nameList = stepNamesConfig.normal;
      if (customNameList?.length) {
        nameList = customNameList;
      } else if (stepWithCoupon) {
        nameList = stepNamesConfig.withCoupon;
      }
      
      return {
        ...state,
        stepWithCoupon,
        stepConfig: defaultStepV2({
          nameList,
          hideFirstStep,
        }),
      }
    },
    stepChange(state, { payload }) {
      const { step, anchorKey = null, sectionKey = null } = payload;
      const stepConfig = getNewStepConfigV2({ newStep: step, oldConfig: state.stepConfig });
      console.log("@@42", step, anchorKey, sectionKey);
      return {
        ...state,
        currentStep: step,
        stepConfig,
        anchorKey,
        sectionKey,
        createStatus: APIStatus.none,
      };
    },
  },

  effects: {

  },
});
